<template>
<div>
    <div class="sheet-body-sub cf">
            <div class="sheet-c1 float-left tsElement">
                <ul class="tsElement-items">
                    <li class="tsElement-item"><i class="ti-menu-alt"></i>Matrisi</li>
                    <li class="tsElement-item"><i class="ti-world"></i>Internet</li>
                    <li class="tsElement-item"><i class="ti-help-alt"></i>Soru</li>
                    <li class="tsElement-item"><i class="ti-printer"></i>Yazdir</li>
                </ul>
            </div>
            <div class="float-right" style="width: 87%">
                <div class="sheet-sub-col cf">
                    <div class="tsCol">
                        <div class="tsCol-title">Bahis Sayisi:</div>
                        <div class="tsCol-count">{{couponDetail.odd_count}}</div>
                    </div>
                    <div class="tsCol">
                        <div class="tsCol-title">Bahis:</div>
                        <div class="tsCol-count">{{couponDetail.amount}} x {{couponDetail.multiplier}} = {{couponDetail.amount*couponDetail.bet_count | toMoney(couponDetail.currency)}}</div>
                    </div>
                    <div class="tsCol">
                        <div class="tsCol-title">Max. Oran:</div>
                        <div class="tsCol-count">{{couponDetail.multiplier}}</div>
                    </div>
                    <div class="tsCol">
                        <div class="tsCol-title">Max. Kazanc:</div>
                        <div class="tsCol-count">{{couponDetail.earnings | toMoney(couponDetail.currency)}}</div>
                    </div>
                  <div class="help_coupon">
                    <div class="ico">
                      <i class="os-icon os-icon-help-circle"></i>
                    </div>
                    <h3>Kuponumda sorun yaşıyorum?</h3>
                    <p>Eğer bahislerinizde bir problem oluştuğunu düşünüyorsanız tıklayarak destek alabilirsiniz.
                    </p>
                  </div>
                </div>
            </div>
        </div>

</div>
</template>

<script>

export default {
    name: 'myBetsCouponDetail',
    data() {
        return {
        }
    },
    props: ['couponDetail']
}
</script>

<style>
.sheet-body-sub{
        min-height: 103px;
        position: relative;
        background: #fff;
        border: none;
    	line-height: 18px;

    }

    .tsElement{
        display: table;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto 0;
        margin-top: 8px;
        padding-left: 0;
        text-align: left;
    }

    .tsElement-items{
        margin:0;
        padding: 0;
    }

    .tsElement-items li{
        list-style: none;
        margin:0;
        border-top: 1px solid #ccc;
        font-size: 11px;
        cursor: pointer;
        color: #7b7b7b;
    }

    .tsElement-items li:last-child{
        border-bottom: 1px solid #ccc;
    }

    .tsElement-items li i {
        padding-left: 30%;
        padding-right: 10px;
        float: left;
        padding-top: 5px;
    }

    .sheet-sub-col{
        width: 100%;
        line-height: 18px;
        background: #fff;
        border: 1px solid #d6d6d6;
        margin-top: 8px;
    }

    .tsCol{
        display: flex;
        width: 100%;
        border-top: 1px solid #ccc;
    }

    .tsCol div {
        flex: 0 50%;
        max-width: 50%;
        font-size: 11px;
    }

    .tsCol:first-child{
        border-top: none;
    }

    .tsCol .tsCol-count{
        justify-content: flex-end;
        display: flex;
        padding-right: 20px;
    }

    .tsCol .tsCol-title{
        justify-content: flex-start;
        display: flex;
        padding-left: 20px;
        color: black;
        font-weight: 500;
    }
    .help_coupon {
      width: 100%;
      height: 70px;
      padding: 0px 15px;
     }
    .help_coupon .ico {
      font-size: 70px;
      float: left;
      padding-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/user/account/myBetsCouponDetail.vue